import hooks from './transfer-methods.hooks';

export default (app) => {
  const service = app.service('api/transfer-methods');

  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };

  service.hooks(hooks);
};
